export default __webpack_public_path__ + "static/media/dashboard-banner.4589b18b.png";